import React from "react";
import StrokeText from "./strokeText";
import { Link } from "gatsby";

/* Button Grid
============================================================================= */

const ButtonGrid = ({ buttons }) => {
	// Config

	// Render Buttons
	const renderButtons = () => {
		return buttons.map((button) => {
			return (
				<Button
					key={button.heading}
					heading={button.heading}
					subheading={button.subheading}
					to={button.to}
				/>
			);
		});
	};

	// Render
	return (
		<div className="w-full grid md:grid-cols-3 grid-cols-1 gap-6 pb-16">
			{renderButtons()}
		</div>
	);
};

/* Button
============================================================================= */

const Button = ({ subheading, heading, to }) => {
	// Config

	// Render
	return (
		<Link to={to} className="col-span-1 bg-gtred p-4">
			<StrokeText
				text={subheading}
				size="text-2xl transform translate-y-3 mb-2"
			/>
			<StrokeText
				text={heading}
				size="text-5xl transform translate-y-3"
			/>
		</Link>
	);
};

/* Export
============================================================================= */

export default ButtonGrid;
